
var tempLocalStorageName = 'ehrLocalStorageEasyFormsInfoDB' + '_' + EMRPracticeModel.PracticeID;//CREATING DB PER PRACTICE


EMRAdmin.factory('LocalStorageFactory', ['$q', '$rootScope', '$filter', 'AuditLogService', '$http', '$state', '$timeout', function ($q, $rootScope, $filter, AuditLogService, $http, $state, $timeout) {
   /**
    * @param {object} obj_LocalStorage used to store all modules data in memory instead of large local storage
    */
    var obj_LocalStorage = Object.create(null);

    var storage;
    var desiredCapacity = 100 * 1024 * 1024; //100MB
    var IsLocalStorageNotInitialized = false;
    var EHRVersion = GetCurrentLoadedEHRVersionNumber();

    var EasyFormsDBCurVersionNumber = 'easyFormVersionInfo^' + EHRVersion;
    var EasyFormtemplateTitle = 'easyformtemplate^';
    var EasyFormtemplateGroupTheraphyTitle = 'easyformgrouptheraphytemplate^';
    var EasyFormSettingsTitle = 'easyformtemplatesettings^';
    //var EasyFormtemplateGoldenThreadCustFields = 'easyformtemplateGoldenThreadCustomizationFields^';
    var EasyFormtemplateCustomOptions = 'easyformtemplatecustomoptions^';
    var EasyFormDataObjectPropertiesdetails = 'EasyFormDataObjectPropertiesdetails^';
    var NoDataFromDataBase = 'NODATAFROMDATABASE';
    var EasyFormHeader = 'easyformtemplate_header^';  

    var DemographicsStatusList = 'demographicsStatusList^';
    var DemographicsCountyList = 'demographicsCountyList^';
    var DemographicsDetailedFieldsCustList = 'demographicsDetailedFieldsList^';
    var DemographicsMaritalStatusList = 'demographicsMaritalStatusList^';
    var DemographicsGenderList = 'demographicsGenderList^';
    var DemographicsStatesList = 'demographicsStatesList^';
    var DemographicsStudentStatusList = 'demographicsStudentStatusList^';
    let RxLinkUnitsList = "RxLinkUnitsList";

    var SearchPtBriefDeatailFieldsList = 'searchPatientBriefDeatailViewFieldsList^';
  //  var SearchPtDetailViewFieldsList = 'searchPatientDetailViewFieldsList^';




    try {
        if (window.navigator.vendor.toLowerCase().indexOf("apple") >= 0 || EHRisMobile.iOS()) {
            IsLocalStorageNotInitialized = true;
            obj_LocalStorage = null;
        }
    } catch (e) {

    }

    var LocalStorageFactoryInstance = {

        //============================================================ LLS START =========================================================================
       
        //Not Using
        InitializeEHRLocalStorage: function () {


            var deferred = $q.defer();

            if (EHRisMobile.any() || IsLocalStorageNotInitialized) {
                setTimeout(function () {
                    deferred.reject();
                });
            }
            else {
                //APENDING VERSION NUMBER
                tempLocalStorageName = tempLocalStorageName;

                if ((typeof LargeLocalStorage).toString().toLowerCase() == "undefined" || (typeof LargeLocalStorage).toString().toLowerCase() == "null") {
                    $timeout(function () {
                        deferred.reject();
                    });
                }
                else {

                    storage = new LargeLocalStorage({

                        size: desiredCapacity,// desired capacity, in bytes.

                        // optional name for your LLS database. Defaults to lls.
                        // This is the name given to the underlying
                        // IndexedDB or WebSQL DB or FSAPI Folder.
                        // LLS's with different names are independent.
                        name: tempLocalStorageName

                        // the following is an optional param 
                        // that is useful for debugging.
                        // force LLS to use a specific storage implementation
                        // forceProvider: 'IndexedDB' or 'WebSQL' or 'FilesystemAPI'
                    });

                    storage.initialized.then(function (capacity) {

                        //console.log(capacity);
                        if (capacity != -1 && capacity != desiredCapacity) {
                            // the user didn't authorize your storage request
                            // so instead you have some limitation on your storage
                        }





                        if (hasValue(storage) && storage.ready()) {
                            //CHECK VERSION INFO
                            LocalStorageFactoryInstance.CheckLocalStorageVersion().then(function (serviceResponse) {
                                deferred.resolve("success");
                            });
                        }
                        else {

                            if (capacity == null)
                                //local storage has not been initialized 
                                IsLocalStorageNotInitialized = true;
                        }

                        //storage.ls().then(function (docKeys) {
                        //    if (docKeys != null && docKeys != undefined && docKeys.length > 0) {
                        //        angular.forEach(docKeys, function (docId) {
                        //            storage.rm(LocalStorageFactoryInstance.getUniqueId(docId)).then(function () {
                        //            });
                        //        });
                        //    }
                        //});
                    });
                }
            }
            return deferred.promise;
        },

        hasValueInLLS: function (inputValue) {
            if (!hasValue(inputValue)) {
                return false;
            }

            if (typeof inputValue == "string" && (inputValue.toString().trim().toUpperCase() == NoDataFromDataBase.trim())) {
                inputValue = null;
                return true;
            } else {
                return true;
            }
        },

        // ============================================================================= SET CONTNET FROM LOCAL STORAGE START ===========================
        SetContentInEHRLocalStorage: function (docId, docData) {

            if (EHRisMobile.any() || !obj_LocalStorage) return;

            if (_.size(docData)) {

                docData = enablePakoJSForCompressDecompression()
                        ? pako.deflate(JSON.stringify(docData), { to: "string" })
                        : LZString144.compressToUTF16(JSON.stringify(docData));
            }
            else {
                docData = NoDataFromDataBase;
            }
            obj_LocalStorage[LocalStorageFactoryInstance.getUniqueId(docId)] = docData;
            // storage.setContents(LocalStorageFactoryInstance.getUniqueId(docId), docData).then(function () {
            // });

        },
        // ============================================================================= SET CONTNET FROM LOCAL STORAGE END ===========================

        getUniqueId: function (docId) {

            //if (window.location.href.indexOf("localhost") >= 0)
            //    return docId + "_" + EMRPracticeModel.PracticeID + "_" + EMRPracticeModel.ApplicationType;
            //else
            return docId + "_" + EMRPracticeModel.PracticeID + "_" + EMRPracticeModel.ApplicationType + "_" + EHRVersion;
        },
//TODO
        CheckLocalStorageVersion: function () {

            var deferred = $q.defer();

            LocalStorageFactoryInstance.GetContentInEHRLocalStorage("easyFormVersionInfo").then(function (serviceResponse) {

                if (isError(serviceResponse) || !LocalStorageFactoryInstance.hasValueInLLS(serviceResponse)) {
                    //NO DATA AVILABLE
                    //SO ADDING DATA
                    LocalStorageFactoryInstance.SetContentInEHRLocalStorage("easyFormVersionInfo", EasyFormsDBCurVersionNumber);//ADDING EASY FORM BINARY TO LLS, IF DATA ALREADY EXISTS, THEN IT WILL OVERRIDE
                    deferred.resolve("success");
                } else {
                    //Version Info Avialbe and Not Matched with Current Version
                    if (typeof serviceResponse == "string" && (serviceResponse.toString().trim().toUpperCase() != EasyFormsDBCurVersionNumber.trim().toUpperCase())) {
                        if (hasValue(storage) && storage.ready()) {
                            storage.clear().then(function () {
                                //console.log('LOCAL STORAGE CLEARED & New Version Details Added to LOCAL STORAGE');
                                LocalStorageFactoryInstance.SetContentInEHRLocalStorage("easyFormVersionInfo", EasyFormsDBCurVersionNumber);//ADDING EASY FORM BINARY TO LLS, IF DATA ALREADY EXISTS, THEN IT WILL OVERRIDE
                                deferred.resolve("success");
                            });// clear the entire database

                        }
                    } else {
                        deferred.resolve("success");
                    }
                }
            });
            return deferred.promise;
        },

        // ============================================================================= GET CONTNET FROM LOCAL STORAGE START ===========================
        GetContentInEHRLocalStorage: function (docId) {
            if (EHRisMobile.any() || !obj_LocalStorage) 
                   return $q.resolve(undefined);
            
            else {
                let contents = obj_LocalStorage[LocalStorageFactoryInstance.getUniqueId(docId)];
                if (!contents || contents == NoDataFromDataBase)
                    return $q.resolve(contents);
                try {
                    const decompressedData = enablePakoJSForCompressDecompression()
                        ? pako.inflate(contents, { to: "string" })
                        : LZString144.decompressFromUTF16(contents);

                    return $q.resolve(JSON.parse(decompressedData));
                } catch (error) {
                    console.error("Error decompressing data:", error);
                    return $q.resolve(undefined);
                }
                // try {
                //     if (hasValue(storage) && storage.ready()) {

                //         $rootScope.$broadcast("ajax-loader-countincrement");

                //         //docId = LocalStorageFactoryInstance.appendDocIDwithVersion(docId);

                //         storage.getContents(LocalStorageFactoryInstance.getUniqueId(docId)).then(function (contents) {

                //             if (contents == NoDataFromDataBase) {
                //                 deferred.resolve(NoDataFromDataBase);
                //             }
                //             else
                //                 deferred.resolve(contents != undefined && contents != null && contents != "" ? JSON.parse(LZString144.decompressFromUTF16(contents)) : undefined);

                //             $rootScope.$broadcast("ajax-loader-countdecrement");

                //         }, function (error) {
                //             $rootScope.$broadcast("ajax-loader-countdecrement");
                //             deferred.resolve(undefined);
                //             console.log('Normal Error Back From Local Storage');
                //         });
                //     }
                //     else {
                //         setTimeout(function () {
                //             deferred.resolve(undefined);
                //         });
                //     }
                // } catch (e) {
                //     //Some Times are getting errors Like 
                //     // -->  Failed to execute 'transaction' on 'IDBDatabase':
                //     $rootScope.$broadcast("ajax-loader-countdecrement");
                //     deferred.resolve(undefined);
                //     console.log('Catch Error Back From Local Storage');
                // }
            }
          //  return deferred.promise;
        },
        // ============================================================================= GET CONTNET FROM LOCAL STORAGE END ===========================

        // ============================================================================= GET CONTNET FROM LOCAL STORAGE START ===========================
       //not using
        GetAllEasyFormIdsInEHRLocalStorage: function () {
          //  var deferred = $q.defer();
            var EasyFormTemplateIDsInLLS = "";//USED TO HOLD ALL EASY FORM TEMPATE IDS PRESENT IN THE LLS
            var EasyFormTemplateIDsInLLSOfOtherPractice = "";//USED TO HOLD ALL EASY FORM TEMPATE IDS PRESENT IN THE LLS
            var EasyFormTemplatePrefix = "_" + EMRPracticeModel.PracticeID + "_" + EMRPracticeModel.ApplicationType;//INDICATES THE PREFIX OF KEY IN LLS

            if (EHRisMobile.any() || !obj_LocalStorage) {
                //setTimeout(function () {
                    $q.resolve(undefined);
                //});
            }
            else {
              
                for (let docId in obj_LocalStorage) {
                    const trimmedString = docId.toString().trim().toLowerCase();
                    if (trimmedString.indexOf(EasyFormTemplatePrefix) >= 0 && trimmedString.indexOf(EasyFormtemplateTitle) >= 0) {
                        //REMOVING SUFFIX
                        docId = docId.substr(EasyFormtemplateTitle.length, docId.length);
                        //REMOVING PREFIX
                        if (docId.lastIndexOf(EasyFormTemplatePrefix) == (docId.length - EasyFormTemplatePrefix.length))
                            docId = docId.substr(0, docId.length - EasyFormTemplatePrefix.length);

                        EasyFormTemplateIDsInLLS = EasyFormTemplateIDsInLLS + docId + ","
                    }

                }
                EasyFormTemplateIDsInLLS = EasyFormTemplateIDsInLLS.trim().trimEnd(",");
                return $q.resolve(EasyFormTemplateIDsInLLS);

    
                // if (hasValue(storage) && storage.ready()) {
                //     storage.ls().then(function (docKeys) {

                //         //LOOPING FOR ALL EASY FORM TEMPLATES IN LLS
                //         if (docKeys != null && docKeys != undefined && docKeys.length > 0) {
                //             for (var index = 0; index < docKeys.length; index++) {

                //                 docId = docKeys[index];//ASSIGING THE EASY FORM ID

                //                 if (docId != undefined && docId != null && docId.toString().length > 0) {

                //                     if (docId.toString().trim().toLowerCase().indexOf(EasyFormTemplatePrefix) >= 0) {

                //                         //VALIDATING TEMPLATE SETTING IS PRESENT OR NOT
                //                         if (docId.toString().trim().toLowerCase().indexOf(EasyFormtemplateTitle) >= 0) {

                //                             //REMOVING SUFFIX
                //                             docId = docId.substr(EasyFormtemplateTitle.length, docId.length);

                //                             //REMOVING PREFIX
                //                             if (docId.lastIndexOf(EasyFormTemplatePrefix) == (docId.length - EasyFormTemplatePrefix.length))
                //                                 docId = docId.substr(0, docId.length - EasyFormTemplatePrefix.length);

                //                             EasyFormTemplateIDsInLLS = EasyFormTemplateIDsInLLS + docId + ","
                //                         }
                //                     }
                //                     else {
                //                         EasyFormTemplateIDsInLLSOfOtherPractice = EasyFormTemplateIDsInLLSOfOtherPractice + docId + ","
                //                     }
                //                 }
                //             }

                //             EasyFormTemplateIDsInLLS = EasyFormTemplateIDsInLLS.trim().trimEnd(",");

                //             if (hasValue(EasyFormTemplateIDsInLLSOfOtherPractice)) {
                //                 //LocalStorageFactoryInstance.RemoveInactiveEasyFormEHRLocalStorageAsyncOtherPracticeData(EasyFormTemplateIDsInLLSOfOtherPractice);//ADDING EASY FORM BINARY TO LLS, IF DATA ALREADY EXISTS, THEN IT WILL OVERRIDE
                //             }

                //             deferred.resolve(EasyFormTemplateIDsInLLS);

                //         }
                //         else {
                //             deferred.resolve(undefined);
                //         }

                //     });
                // }

                // else {
                //     setTimeout(function () {
                //         deferred.resolve(undefined);
                //     });
                // }
            }
           // return deferred.promise;
        },
        // ============================================================================= GET CONTNET FROM LOCAL STORAGE END ===========================

        // ============================================================================= REMOVE SELECTED CONTNET IN LOCAL STORAGE START ===========================
        RemoveContentInEHRLocalStorage: function (docId) {
            if (EHRisMobile.any() || !obj_LocalStorage) {
                return;
            }
            obj_LocalStorage[LocalStorageFactoryInstance.getUniqueId(docId)] = null;

            // if (hasValue(storage) && storage.ready()) {

            //     storage.rm(LocalStorageFactoryInstance.getUniqueId(docId)).then(function () {
            //         //alert('doc and all attachments were removed');
            //     });
            // }
        },
        // ============================================================================= REMOVE SELECTED CONTNET IN LOCAL STORAGE END ===========================
//Not Using
        // RemoveInactiveEasyFormEHRLocalStorageAsyncOtherPracticeData: function (InactiveEasyFormTemplateIDs) {

        //     var deferred = $q.defer();

        //     if (EHRisMobile.any() || IsLocalStorageNotInitialized) {
        //         setTimeout(function () {
        //             deferred.resolve('success');
        //         })
        //     }

        //     else {
        //         if (hasValue(storage) && storage.ready()) {

        //             if (InactiveEasyFormTemplateIDs != undefined && InactiveEasyFormTemplateIDs != null && InactiveEasyFormTemplateIDs.toString().length > 0) {

        //                 var docKeys = InactiveEasyFormTemplateIDs.toString().split(',');

        //                 //LOOPING FOR ALL EASY FORM TEMPLATES IN LLS
        //                 if (docKeys != null && docKeys != undefined && docKeys.length > 0) {

        //                     for (var index = 0; index < docKeys.length; index++) {

        //                         docId = docKeys[index];//ASSIGING THE EASY FORM ID

        //                         if (docId != undefined && docId != null && docId.toString().length > 0) {

        //                             storage.rm(docId).then(function () {
        //                                 //alert('doc and all attachments were removed');
        //                             });
        //                         }
        //                     }
        //                 }
        //             }
        //         }
        //         else {
        //             setTimeout(function () {
        //                 deferred.resolve('success');
        //             })
        //         }
        //     }
        //     return deferred.promise;
        // },

        // ============================================================================= GET CONTNET FROM LOCAL STORAGE START ===========================
        RemoveInactiveEasyFormEHRLocalStorage: function (InactiveEasyFormTemplateIDs) {

            if (EHRisMobile.any()) {
                return;
            }
            if (obj_LocalStorage && InactiveEasyFormTemplateIDs) {
                var docKeys = InactiveEasyFormTemplateIDs.toString().split(',');
                for (const docId of docKeys) {
                    //1. EASY FORM BINARY DATA
                    obj_LocalStorage[LocalStorageFactoryInstance.getUniqueId(EasyFormtemplateTitle + docId)] = null;
                    //2. SETTINGS DATA
                    obj_LocalStorage[LocalStorageFactoryInstance.getUniqueId(EasyFormSettingsTitle + docId)] = null;
                    //3. Data Object Properties
                    obj_LocalStorage[LocalStorageFactoryInstance.getUniqueId(EasyFormDataObjectPropertiesdetails + docId)] = null;
                    //4. CUSTOM OPTIONS OPTIONS DATA
                    obj_LocalStorage[LocalStorageFactoryInstance.getUniqueId(EasyFormtemplateCustomOptions + docId)] = null;

                }
            }

            // if (hasValue(storage) && storage.ready()) {

            //     if (InactiveEasyFormTemplateIDs != undefined && InactiveEasyFormTemplateIDs != null && InactiveEasyFormTemplateIDs.toString().length > 0) {

            //         var docKeys = InactiveEasyFormTemplateIDs.toString().split(',');

            //         //LOOPING FOR ALL EASY FORM TEMPLATES IN LLS
            //         if (docKeys != null && docKeys != undefined && docKeys.length > 0) {

            //             for (var index = 0; index < docKeys.length; index++) {

            //                 var docId = docKeys[index];//ASSIGING THE EASY FORM ID

            //                 if (docId != undefined && docId != null && docId.toString().length > 0) {

            //                     console.log('Removing Easy Form Data from Local Storage');
            //                     //REMOVING 

            //                     //1. EASY FORM BINARY DATA
            //                     LocalStorageFactoryInstance.RemoveContentInEHRLocalStorage(EasyFormtemplateTitle + docId);
            //                     //console.log('Easy Form Binary Data removed from LLS...');

            //                     //2. SETTINGS DATA
            //                     LocalStorageFactoryInstance.RemoveContentInEHRLocalStorage(EasyFormSettingsTitle + docId);
            //                     //console.log('Easy Form Settings Data removed From LLS...');

            //                     ////3. GOLDEN THREAD CUST OPTIONS DATA
            //                     //LocalStorageFactoryInstance.RemoveContentInEHRLocalStorage(EasyFormtemplateGoldenThreadCustFields + docId);
            //                     ////console.log('Easy Form Golden Thread Custom Fields Data removed From LLS...');

            //                     //4. GOLDEN THREAD CUST OPTIONS DATA
            //                     LocalStorageFactoryInstance.RemoveContentInEHRLocalStorage(EasyFormDataObjectPropertiesdetails + docId);
            //                     //console.log('Easy Form Custom Options Data removed From LLS...');

            //                     //4. GOLDEN THREAD CUST OPTIONS DATA
            //                     LocalStorageFactoryInstance.RemoveContentInEHRLocalStorage(EasyFormtemplateCustomOptions + docId);
            //                     //console.log('Easy Form Custom Options Data removed From LLS...');



            //                 }
            //             }
            //         }
            //     }
            // }
        },
        // ============================================================================= GET CONTNET FROM LOCAL STORAGE END ===========================

        // ============================================================================= REMOVE ALL CONTNET IN LOCAL STORAGE START =============================
       //Not Using
        RemoveAllContentInEHRLocalStorage: function () {
           // var deferred = $q.defer();

            if (EHRisMobile.any()) {
               // setTimeout(function () {
                   // deferred.resolve("success");
               // });
            }
            else {
                obj_LocalStorage = {};
             
                // if (hasValue(storage) && storage.ready()) {

                //     storage.ls().then(function (docKeys) {

                //         if (docKeys != null && docKeys != undefined && docKeys.length > 0) {
                //             angular.forEach(docKeys, function (docId, index) {
                //                 storage.rm(LocalStorageFactoryInstance.getUniqueId(docId)).then(function () {
                //                     if (index == docKeys.length - 1) {
                //                         deferred.resolve("success");
                //                     }
                //                 }, function () {
                //                     if (index == docKeys.length - 1) {
                //                         deferred.resolve("success");
                //                     }
                //                 });
                //             });
                //         }
                //         else {
                //             deferred.resolve("success");
                //         }

                //     });
                // } else {
                //     setTimeout(function () {
                //         deferred.resolve("success");
                //     });
                // }
            }
            return $q.resolve("success");

           // return deferred.promise;
        },
        // ============================================================================= REMOVE ALL CONTNET IN LOCAL STORAGE END =============================
//NOt Using
        RemoveContentInEHRLocalStorageAsync: function (docId) {

           // var deferred = $q.defer();

            if (EHRisMobile.any() || !obj_LocalStorage) {
             //   setTimeout(function () {
                   return $q.resolve('success');
               // })
            }
            else {
                    obj_LocalStorage[LocalStorageFactoryInstance.getUniqueId(docId)] = null;
                
                 return $q.resolve('success');
                // if (hasValue(storage) && storage.ready()) {

                //     storage.rm(LocalStorageFactoryInstance.getUniqueId(docId)).then(function () {
                //         deferred.resolve('success');
                //     }, function () {
                //         deferred.resolve('success');
                //     });
                // }
                // else {
                //     setTimeout(function () {
                //         deferred.resolve('success');
                //     })
                // }
            }

          //  return deferred.promise;
        },

        RemoveInactiveEasyFormEHRLocalStorageAsync: function (InactiveEasyFormTemplateIDs) {

          //  var deferred = $q.defer();

            if (EHRisMobile.any()) 
                return $q.resolve('success');
            
            else {
                if (obj_LocalStorage && InactiveEasyFormTemplateIDs) {
                    var docKeys = InactiveEasyFormTemplateIDs.toString().split(',');
                    for (const docId of docKeys) {
                        //1. EASY FORM BINARY DATA
                        obj_LocalStorage[LocalStorageFactoryInstance.getUniqueId(EasyFormtemplateTitle + docId)] = null;
                        //2. SETTINGS DATA
                        obj_LocalStorage[LocalStorageFactoryInstance.getUniqueId(EasyFormSettingsTitle + docId)] = null;
                        //3. Data Object Properties
                        obj_LocalStorage[LocalStorageFactoryInstance.getUniqueId(EasyFormDataObjectPropertiesdetails + docId)] = null;
                        //4. CUSTOM OPTIONS OPTIONS DATA
                        obj_LocalStorage[LocalStorageFactoryInstance.getUniqueId(EasyFormtemplateCustomOptions + docId)] = null;
                        //5. GROUP THERAPHY BINARY
                        obj_LocalStorage[LocalStorageFactoryInstance.getUniqueId(EasyFormtemplateGroupTheraphyTitle + docId)] = null;
                        obj_LocalStorage[LocalStorageFactoryInstance.getUniqueId(enumLocalStorageFileType.EasyFormHeader + docId)] = null;
                        //5.ON LOAD AUTO POPULATION CATEGORIES LIST 
                        obj_LocalStorage[LocalStorageFactoryInstance.getUniqueId(enumLocalStorageFileType.EasyFormAutoPopulationCategoriesList + docId)] = null;
                        //6.ANY TIME AUTO POPULATION CATEGORIES LIST 
                        obj_LocalStorage[LocalStorageFactoryInstance.getUniqueId(enumLocalStorageFileType.EasyFormAnyTimeAutoPopulationCategoriesList + docId)] = null;
                        //7. REMOVE CUSTOMIZED FIELDS VALIDATION INFO FROM LLS
                        obj_LocalStorage[LocalStorageFactoryInstance.getUniqueId(enumLocalStorageFileType.EasyFormCustomizedValidationFieldsInfo + docId)] = null;
                        //8. REMOVE EASYFORM CUSTOMIZED STATIC CALUCLATED HCI FIELDS INFO FROM LOCAL STORAGE
                        // if any template customization cahnges then need to remove template linked data from lls
                        // so for this we called a centralized function to remove content from the lls
                        obj_LocalStorage[LocalStorageFactoryInstance.getUniqueId(enumLocalStorageFileType.EasyFormCustomizedStaticCalculatedHCIFieldsInfo + docId)] = null;

                    }
                }
                return $q.resolve('success');
                // if (hasValue(storage) && storage.ready()) {

                //     if (InactiveEasyFormTemplateIDs != undefined && InactiveEasyFormTemplateIDs != null && InactiveEasyFormTemplateIDs.toString().length > 0) {

                //         var docKeys = InactiveEasyFormTemplateIDs.toString().split(',');

                //         //LOOPING FOR ALL EASY FORM TEMPLATES IN LLS
                //         if (docKeys != null && docKeys != undefined && docKeys.length > 0) {

                //             for (var index = 0; index < docKeys.length; index++) {

                //                 var docId = docKeys[index];//ASSIGING THE EASY FORM ID

                //                 if (docId != undefined && docId != null && docId.toString().length > 0) {

                //                     console.log('=== Removing Easy Form Data from Local Storage ===');
                //                     //REMOVING 

                //                     //1. EASY FORM BINARY DATA
                //                     LocalStorageFactoryInstance.RemoveContentInEHRLocalStorageAsync(EasyFormtemplateTitle + docId).then(function () {
                //                         //console.log('Easy Form - Binary Data removed from LLS...');

                //                         //2. SETTINGS DATA
                //                         LocalStorageFactoryInstance.RemoveContentInEHRLocalStorageAsync(EasyFormSettingsTitle + docId).then(function () {
                //                             //console.log('Easy Form - Settings Data removed From LLS...');

                //                             //3. Data Object Properties
                //                             LocalStorageFactoryInstance.RemoveContentInEHRLocalStorageAsync(EasyFormDataObjectPropertiesdetails + docId).then(function () {

                //                                 //console.log('Easy Form - Data Object Properties details Data removed From LLS...');

                //                                 //4. CUSTOM OPTIONS OPTIONS DATA
                //                                 LocalStorageFactoryInstance.RemoveContentInEHRLocalStorageAsync(EasyFormtemplateCustomOptions + docId).then(function () {

                //                                     //console.log('Easy Form - Custom Options Data removed From LLS...');

                //                                     //4. GROUP THERAPHY BINARY
                //                                     LocalStorageFactoryInstance.RemoveContentInEHRLocalStorageAsync(EasyFormtemplateGroupTheraphyTitle + docId).then(function () {

                //                                         //console.log('Group Theraphy Easy Form Binary Data removed From LLS...');
                //                                         //deferred.resolve('success');

                //                                         LocalStorageFactoryInstance.RemoveContentInEHRLocalStorageAsync(enumLocalStorageFileType.EasyFormHeader + docId).then(function () {

                //                                             //console.log('Group Theraphy Easy Form Binary Data removed From LLS...');

                //                                             //5.ON LOAD AUTO POPULATION CATEGORIES LIST 
                //                                             LocalStorageFactoryInstance.RemoveContentInEHRLocalStorageAsync(enumLocalStorageFileType.EasyFormAutoPopulationCategoriesList + docId).then(function () {

                //                                                 //console.log('On load Auto Population categories list removed From LLS...');

                //                                                 //6.ANY TIME AUTO POPULATION CATEGORIES LIST 
                //                                                 LocalStorageFactoryInstance.RemoveContentInEHRLocalStorageAsync(enumLocalStorageFileType.EasyFormAnyTimeAutoPopulationCategoriesList + docId).then(function () {

                //                                                     //console.log('Any Time Auto Population categories list removed From LLS...');

                //                                                     //7. REMOVE CUSTOMIZED FIELDS VALIDATION INFO FROM LLS
                //                                                     LocalStorageFactoryInstance.RemoveContentInEHRLocalStorageAsync(enumLocalStorageFileType.EasyFormCustomizedValidationFieldsInfo + docId).then(function () {

                //                                                         //8. REMOVE EASYFORM CUSTOMIZED STATIC CALUCLATED HCI FIELDS INFO FROM LOCAL STORAGE
                //                                                         // if any template customization cahnges then need to remove template linked data from lls
                //                                                         // so for this we called a centralized function to remove content from the lls
                //                                                         LocalStorageFactoryInstance.RemoveContentInEHRLocalStorageAsync(enumLocalStorageFileType.EasyFormCustomizedStaticCalculatedHCIFieldsInfo + docId).then(function () {
                                                                           
                //                                                             deferred.resolve('success');

                //                                                         });   
                //                                                     });    
                //                                                 });                                                            
                //                                             });                                                           
                //                                         });
                //                                     });
                //                                 });
                //                             });
                //                         });
                //                     });
                //                 }
                //             }
                //         }
                //     }
                // }
                // else {
                //     setTimeout(function () {
                //         deferred.resolve('success');
                //     })
                // }
            }
          //  return deferred.promise;
        },


        CheckLocalStorageExistorNotandShowMessage: function () {
            if (EHRisMobile.any())
               return;
            if (typeof obj_LocalStorage === 'object') 
                ShowErrorMessage("Please Reload Easy Form to Apply Changes.");
            
            // if (EHRisMobile.any() || IsLocalStorageNotInitialized) {
            //     return;
            // } else if (!hasValue(storage)) {
            //     return;
            // } else {
            //     if (hasValue(storage) && storage.ready()) {
            //         ShowErrorMessage("Please Reload Easy Form to Apply Changes.");
            //     }
            // }
        },

        CheckIsLocalStorageAvailable: function () {
            if (EHRisMobile.any())
                return false;
            else return typeof obj_LocalStorage === 'object';
            //     return false;
            // }
            // if (EHRisMobile.any() || IsLocalStorageNotInitialized) {
            //     return false;
            // } else if (!hasValue(storage)) {
            //     return false;
            // } else {
            //     return hasValue(storage) && storage.ready();
            // }
        },
        //not using
        // IsLocalStorageHasReady: function () {
        //     return IsLocalStorageNotInitialized || (hasValue(storage) && storage.ready());
        // },


        appendDocIDwithVersion: function (docId) {

            return docId + "_" + GetCurrentLoadedEHRVersionNumber();
        },


        RemoveDemographicsContentInEHRLocalStorageAsync: function (key) {
            if (EHRisMobile.any() || !obj_LocalStorage) {
                return;
            }
            if (key)
                obj_LocalStorage[LocalStorageFactoryInstance.getUniqueId(key)] = null;
            else {
                obj_LocalStorage[LocalStorageFactoryInstance.getUniqueId(DemographicsStatusList + EMRPracticeModel.PracticeID)] = null;
                obj_LocalStorage[LocalStorageFactoryInstance.getUniqueId(DemographicsCountyList + EMRPracticeModel.PracticeID)] = null;
                obj_LocalStorage[LocalStorageFactoryInstance.getUniqueId(DemographicsMaritalStatusList + EMRPracticeModel.PracticeID)] = null;
                obj_LocalStorage[LocalStorageFactoryInstance.getUniqueId(DemographicsGenderList + EMRPracticeModel.PracticeID)] = null;
                obj_LocalStorage[LocalStorageFactoryInstance.getUniqueId(DemographicsStatesList + EMRPracticeModel.PracticeID)] = null;
                obj_LocalStorage[LocalStorageFactoryInstance.getUniqueId(DemographicsStudentStatusList + EMRPracticeModel.PracticeID)] = null;
                obj_LocalStorage[LocalStorageFactoryInstance.getUniqueId(DemographicsDetailedFieldsCustList + EMRPracticeModel.PracticeID)] = null;
                obj_LocalStorage["searchPatientBriefDeatailViewFieldsList^" + EMRPracticeModel.PracticeID + "^1^1"] = null;
                obj_LocalStorage["searchPatientBriefDeatailViewFieldsList^" + EMRPracticeModel.PracticeID + "^1^2"] = null;
                obj_LocalStorage["searchPatientBriefDeatailViewFieldsList^" + EMRPracticeModel.PracticeID + "^2^1"] = null;
                obj_LocalStorage["searchPatientBriefDeatailViewFieldsList^" + EMRPracticeModel.PracticeID + "^2^2"] = null;
                obj_LocalStorage[LocalStorageFactoryInstance.getUniqueId(RxLinkUnitsList + EMRPracticeModel.PracticeID)] = null;
            }
            // if (hasValue(key)) {
            //     LocalStorageFactoryInstance.RemoveContentInEHRLocalStorage(key);
            //     console.log("Removed - " + key);
            // }
            // else {
            //     LocalStorageFactoryInstance.RemoveContentInEHRLocalStorage(DemographicsStatusList + EMRPracticeModel.PracticeID);
            //     console.log("Demographics Status Removed from Local Storage");

            //     LocalStorageFactoryInstance.RemoveContentInEHRLocalStorage(DemographicsCountyList + EMRPracticeModel.PracticeID);
            //     console.log("Demographics County Removed from Local Storage");

            //     LocalStorageFactoryInstance.RemoveContentInEHRLocalStorage(DemographicsMaritalStatusList + EMRPracticeModel.PracticeID);
            //     console.log("Marital Status Removed from Local Storage");

            //     LocalStorageFactoryInstance.RemoveContentInEHRLocalStorage(DemographicsGenderList + EMRPracticeModel.PracticeID);
            //     console.log("Gender List Removed from Local Storage");

            //     LocalStorageFactoryInstance.RemoveContentInEHRLocalStorage(DemographicsStatesList + EMRPracticeModel.PracticeID);
            //     console.log("USA STATES List Removed from Local Storage");

            //     LocalStorageFactoryInstance.RemoveContentInEHRLocalStorage(DemographicsStudentStatusList + EMRPracticeModel.PracticeID);
            //     console.log("Student Status List Removed from Local Storage");

            //     LocalStorageFactoryInstance.RemoveContentInEHRLocalStorage(DemographicsDetailedFieldsCustList + EMRPracticeModel.PracticeID);
            //     console.log("Demographics Detailed Fields Removed from Local Storage");

            //     LocalStorageFactoryInstance.RemoveContentInEHRLocalStorage("searchPatientBriefDeatailViewFieldsList^" + EMRPracticeModel.PracticeID + "^1^1");
            //     LocalStorageFactoryInstance.RemoveContentInEHRLocalStorage("searchPatientBriefDeatailViewFieldsList^" + EMRPracticeModel.PracticeID + "^1^2");
            //     LocalStorageFactoryInstance.RemoveContentInEHRLocalStorage("searchPatientBriefDeatailViewFieldsList^" + EMRPracticeModel.PracticeID + "^2^1");
            //     LocalStorageFactoryInstance.RemoveContentInEHRLocalStorage("searchPatientBriefDeatailViewFieldsList^" + EMRPracticeModel.PracticeID + "^2^2");
            //     console.log("Search Fields Removed from Local Storage");

            // }
        },

    };





    return LocalStorageFactoryInstance;
    //==================================================================================== LLS END ========================================================================================
}]);